import { useContext } from 'react';

import { DeleteLifeAreaSectionContext } from './delete-life-area-section-context';

export const useOpenDeleteLifeAreaSectionDialog = () => {
  const { onDeleteLifeAreaSection } = useContext(DeleteLifeAreaSectionContext);

  return onDeleteLifeAreaSection;
};
